module.exports = __webpack_public_path__ + "static/media/3020.26aebe92.jpg";